import {
	FETCH_PARTNERS,
	FETCH_WORKOUT_CATS,
	FETCH_PROGRAM_CATS,
	FETCH_WORKOUTS,
	UPDATE_PARTNER_ASSIGNMENTS,
	FETCH_PROGRAMS,
	FETCH_GROUPS,
	FETCH_PARTNER_ASSIGNMENTS,
	FETCH_EMAIL_ASSIGNMENTS,
	ADD_GROUP,
	FETCH_CLIENTS,
	ADD_CLIENT,
	RESET_CLIENTS,
	RESET_GROUPS
} from '../actionTypes';
import axios from 'axios';
import { showLoader, hideLoader } from './loader';
import { showAlert } from './alert';
import { checkState, paginationLimit } from './../../helpers'


const SERVICE = 'assignments';
export const createGroup = (groupData, emails) => dispatch => {
	dispatch(showLoader());
	const _id = groupData._id;
	if(_id) {
		delete groupData._id;
		return new Promise((response, reject) => {
			axios
				.patch(`groups/${_id}`, groupData)
				.then(res => {
					dispatch({
						type: ADD_GROUP,
						payload: res.data,
					});
					dispatch(showAlert('Group edited successfully.'));
					dispatch(hideLoader());
					response(res.data);
				})
				.catch(e => {
					dispatch(hideLoader());
					if (e.response)
						dispatch(showAlert(e.response.data.error.message || e.message, true));
					else dispatch(showAlert('Something went wrong', true));
					reject(e);
				});
		});
	} else {
		return new Promise((response, reject) => {
			axios
				.post('groups', groupData)
				.then(res => {
					const group = res.data;
					dispatch({
						type: ADD_GROUP,
						payload: group,
					});
					dispatch(showAlert('Group created successfully.'));
					dispatch(hideLoader());
					response(group);
				})
				.catch(err => {
					dispatch(hideLoader());
					if (err.response)
						dispatch(
							showAlert(err.response.data.error.message || err.message, true)
						);
					else dispatch(showAlert('Something went wrong', true));
					reject(err);
				});
		});
	}
};



export const createClient = clientData => dispatch => {
	dispatch(showLoader());
	const _id = clientData._id;
	if(_id) {
		delete clientData._id;
		return new Promise((response, reject) => {
			axios
				.patch(`clients/${_id}`, clientData)
				.then(res => {
					dispatch({
						type: ADD_CLIENT,
						payload: res.data,
					});
					dispatch(showAlert('Client edited successfully.'));
					dispatch(hideLoader());
					response(res.data);
				})
				.catch(e => {
					dispatch(hideLoader());
					if (e.response)
						dispatch(showAlert(e.response.data.error.message || e.message, true));
					else dispatch(showAlert('Something went wrong', true));
					reject(e);
				});
		});
	} else {
		return new Promise((response, reject) => {
			axios
				.post('clients', clientData)
				.then(res => {
					dispatch({
						type: ADD_CLIENT,
						payload: res.data,
					});
					dispatch(showAlert('Client created successfully. Please search client with the first name.'));
					dispatch(hideLoader());
					response(res.data);
				})
				.catch(e => {
					dispatch(hideLoader());
					if (e.response)
						dispatch(showAlert(e.response.data.error.message || e.message, true));
					else dispatch(showAlert('Something went wrong', true));
					reject(e);
				});
		});

	}
	
};

export const createAction = data => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
			.post('actions', data)
			.then(res => {
				dispatch(showAlert('Committed Action saved successfully.'));
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(e => {
				dispatch(hideLoader());
				if (e.response)
					dispatch(showAlert(e.response.data.error.message || e.message, true));
				else dispatch(showAlert('Something went wrong', true));
				reject(e);
			});
	});

	
	
};

export const createScheduleMessage = data => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
			.post('scheduleMessages', data)
			.then(res => {
				dispatch(showAlert(res.data.message));
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(e => {
				dispatch(hideLoader());
				if (e.response)
					dispatch(showAlert(e.response.data.error.message || e.message, true));
				else dispatch(showAlert('Something went wrong', true));
				reject(e);
			});
	});
	
};



export const createScheduleCall = data => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
			axios
				.post('actions/scheduleCall', data)
				.then(res => {
					dispatch(showAlert('Deadline Time saved successfully.'));
					dispatch(hideLoader());
					response(res.data);
				})
				.catch(e => {
					dispatch(hideLoader());
					if (e.response)
						dispatch(showAlert(e.response.data.error.message || e.message, true));
					else dispatch(showAlert('Something went wrong', true));
					reject(e);
				});
	});
};

export const createMileStones = data => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
			axios
				.post('actions/milestones', data)
				.then(res => {
					dispatch(showAlert('Milestones saved successfully.'));
					dispatch(hideLoader());
					response(res.data);
				})
				.catch(e => {
					dispatch(hideLoader());
					if (e.response)
						dispatch(showAlert(e.response.data.error.message || e.message, true));
					else dispatch(showAlert('Something went wrong', true));
					reject(e);
				});
	});
};

export const createPARQ = data => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
			axios
				.post('actions/parqs', data)
				.then(res => {
					dispatch(showAlert(res.data.message));
					dispatch(hideLoader());
					response(res.data);
				})
				.catch(e => {
					dispatch(hideLoader());
					if (e.response)
						dispatch(showAlert(e.response.data.error.message || e.message, true));
					else dispatch(showAlert('Something went wrong', true));
					reject(e);
				});
	});
};

export const saveBodyMatrix = data => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
			axios
				.post('actions/bodyMatrix', data)
				.then(res => {
					dispatch(showAlert(res.data.message));
					dispatch(hideLoader());
					response(res.data);
				})
				.catch(e => {
					dispatch(hideLoader());
					if (e.response)
						dispatch(showAlert(e.response.data.error.message || e.message, true));
					else dispatch(showAlert('Something went wrong', true));
					reject(e);
				});
	});
};

export const saveWeightMatric = data => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
			axios
				.post('actions/weightMetric', data)
				.then(res => {
					dispatch(showAlert(res.data.message));
					dispatch(hideLoader());
					response(res.data);
				})
				.catch(e => {
					dispatch(hideLoader());
					if (e.response)
						dispatch(showAlert(e.response.data.error.message || e.message, true));
					else dispatch(showAlert('Something went wrong', true));
					reject(e);
				});
	});
};


export const deleteActionRange = id => dispatch => {
	if (!id) {
		console.error('action does not have id');
		return false;
	}
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
		.delete(`actions/ranges/${id}`)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('Committed Action deleted successfully.'));
			response(res);
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
	})
}

export const deleteScheduleMessage = id => dispatch => {
	if (!id) {
		console.error('message does not have id');
		return false;
	}
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
		.delete(`scheduleMessages/${id}`)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('Message deleted successfully.'));
			response(res);
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
	})
}


export const deleteBodyMatrixRange = id => dispatch => {
	if (!id) {
		console.error('bodymatrix does not have id');
		return false;
	}
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
		.delete(`actions/bodyMatrix/ranges/${id}`)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('Body Matrix deleted successfully.'));
			response(res);
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
	})
}

export const deleteWeightMetricRange = id => dispatch => {
	if (!id) {
		console.error('weight metric does not have id');
		return false;
	}
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
		.delete(`actions/weightMetric/ranges/${id}`)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('Weight Metric deleted successfully.'));
			response(res);
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
	})
}


export const updateActionStatus = (id, type, status) => dispatch => {
	if (!id) {
		console.error('data does not have id');
		return false;
	}
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
		.patch(`actions/updateStatus/${type}/${id}`, {
			isCompleted: status
		})
		.then(res => {
			dispatch(hideLoader());
			response(res);
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
	})
}

export const deleteMileStones = id => dispatch => {
	if (!id) {
		console.error('milestone does not have id');
		return false;
	}
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
		.delete(`actions/milestone/${id}`)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('MileStone deleted successfully.'));
			response(res);
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
	})
}

export const deletePARQ = id => dispatch => {
	if (!id) {
		console.error('parq does not have id');
		return false;
	}
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
		.delete(`actions/parqs/${id}`)
		.then(res => {
			dispatch(hideLoader());
			dispatch(showAlert('PAR-Q deleted successfully.'));
			response(res);
		})
		.catch(function (error) {
			dispatch(hideLoader());
			dispatch(showAlert(error.toString(), true));
		});
	})
}

export const createEmailAssignments = assigns => dispatch => {
	dispatch(showLoader());
	let alreadyAssigned = [];
	return new Promise((response, reject) => {
		const postUrl = SERVICE;
		const postAssignments = assigns.map(assign => {
			if (assign.type === 'workout') {
				assign['workoutId'] = assign.typeId;
			}
			if (assign.type === 'program') {
				assign['programId'] = assign.typeId;
			}
			return axios.post(postUrl, assign);
		});
		Promise.all(postAssignments)
			.then(responses => {
				responses.forEach(response => {
					const data = response.data;
					if (data.isAssignmentExist) {
						alreadyAssigned.push(data);
					}
				});
				dispatch(hideLoader());
				response(alreadyAssigned);
			})
			.catch(err => {
				dispatch(hideLoader());
				if (err.response) {
					dispatch(showAlert(err.response.data.error.message, true));
				}
				reject(err);
			});
	});
};

export const assignPartnerWorkouts = workoutIds => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		const url = `partner-assignments`;
		axios
			.post(url, { workoutIds: workoutIds })
			.then(res => {
				dispatch({
					type: UPDATE_PARTNER_ASSIGNMENTS,
					payload: res.data,
				});
				dispatch(hideLoader());
				dispatch(showAlert('Assignment is created successfully.'));
				response(res);
			})
			.catch(function (error) {
				dispatch(hideLoader());
			});
	});
};

//SHOULD BE RENANED TO FETCH MY PARTNERS,
// function will get all of the users belonging to that trainer
export const fetchPartners = userId => dispatch => {
	dispatch(showLoader());
	axios
		.get('partners', {
			params: {
				trainerId: userId,
				_expand: ['user'],
			},
		})
		.then(res => {
			dispatch({
				type: FETCH_PARTNERS,
				payload: res.data,
			});
			dispatch(hideLoader());
		})
		.catch(function (error) {
			console.warn(error);
			dispatch(hideLoader());
		});
};

export const fetchMileStones = (userId, param) => dispatch => {
	dispatch(showLoader());
	if(param.skip && param.skip!== 0) {
		dispatch(hideLoader());
	}
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`actions/milestones`, {
				params: param,
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchPARQS = (userId, param) => dispatch => {
	dispatch(showLoader());
	if(param.skip && param.skip!== 0) {
		dispatch(hideLoader());
	}
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`actions/parqs`, {
				params: param,
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchScheduleCall = (userId, param) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`actions/scheduleCall`, {
				params: param,
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchBodyMatrixMetas = () => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`actions/bodyMatrixMeta`, {
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchActions = (userId, rangeIds) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`actions/rangesByIds?rangeIds[]=${rangeIds}`, {
				params: {
				},
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchClientNotes = (params) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`/plan-notes/notes`, {
				params: {...params },
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};




export const fetchScheduleMessageDetail = (userId, messageIds) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`scheduleMessages/messageByIds?messageIds[]=${messageIds}`, {
				params: {
				},
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchBodyMatrix = (userId, rangeIds) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`actions/bodyMatrix/rangesByIds?rangeIds[]=${rangeIds}`, {
				params: {
				},
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchWeightMetric = (userId, rangeIds) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`actions/weightMetric/rangesByIds?rangeIds[]=${rangeIds}`, {
				params: {
				},
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchAsignments = (userId, param) => dispatch => {
	if ( param && param.params && param.params.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get('assignments', {
				params: {
					trainerId: userId,
					startDate: param && param.params && param.params.startDate,
					_expand: [param && param.params && param.params.type],
					type: param && param.params && param.params.type,
					limit: param && param.params && param.params.limit,
					skip: param && param.params && param.params.skip,
					platform: 'desktop',
					search:
						param &&
						param.params &&
						param.params.search &&
						param.params.search.length &&
						param.params.search,
				},
			})
			.then(res => {
				dispatch({
					type: FETCH_EMAIL_ASSIGNMENTS,
					payload: res.data,
				});
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchScheduleMessages = (userId, param) => dispatch => {
	if ( param && param.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get('scheduleMessages', {
				params: {
					trainerId: userId,
					clientEmail: param.clientEmail,
					skip: param.skip,
					limit: param.limit,
					isEvent: param.isEvent,
					isSent: param.isSent,
					date: param.date,
					search: param.search,
					startDate: param.startDate,
					isAutomation: param.isAutomation
				},
			})
			.then(res => {
				dispatch({
					type: FETCH_EMAIL_ASSIGNMENTS,
					payload: res.data,
				});
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchActionRanges = (userId, param) => dispatch => {
	if ( param && param.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get('actions/ranges', {
				params: {
					trainerId: userId,
					clientEmail: param.clientEmail,
					skip: param.skip,
					limit: param.limit
				},
			})
			.then(res => {
				dispatch({
					type: FETCH_EMAIL_ASSIGNMENTS,
					payload: res.data,
				});
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};



export const fetchWeightMetricRanges = (userId, param) => dispatch => {
	if ( param && param.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get('actions/weightMetric/ranges', {
				params: {
					trainerId: userId,
					clientEmail: param.clientEmail,
					skip: param.skip,
					limit: param.limit
				},
			})
			.then(res => {
				dispatch({
					type: FETCH_EMAIL_ASSIGNMENTS,
					payload: res.data,
				});
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchBodyMatrixRanges = (userId, param) => dispatch => {
	if ( param && param.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get('actions/bodyMatrix/ranges', {
				params: {
					trainerId: userId,
					clientEmail: param.clientEmail,
					skip: param.skip,
					limit: param.limit
				},
			})
			.then(res => {
				dispatch({
					type: FETCH_EMAIL_ASSIGNMENTS,
					payload: res.data,
				});
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const updateAssignments = (_id, status) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios
			.patch(`assignments/${_id}`, {
				isAssign: status
			})
			.then(res => {
				dispatch(showAlert(`Assignment has been successfully ${status ? 'assigned': 'unassigned'}.`));
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(e => {
				dispatch(hideLoader());
				if (e.response)
					dispatch(showAlert(e.response.data.error.message || e.message, true));
				else dispatch(showAlert('Something went wrong', true));
				reject(e);
			});
	});
}


export const getPlanNotes = (param) => dispatch => {
	const url = `${'workouts/getPlanNotes'}/${param.workoutId}`
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(url, {
				params: {
					email: param.email
				},
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchFormValues = userId => (dispatch, getState) => {
	let promises = [];
	dispatch(showLoader());
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	const state = getState();
	const { equipment, exerciseCats, workoutCats, programCats, products } = state;
	
	promises = checkState(promises, 'categories',  {
		type: 'workout'
	}, workoutCats)
	promises = checkState(promises, 'categories',  {
		type: 'program'
	}, programCats)

	promises.push(
		axios.get(`workouts`, {
			params: {
				limit: paginationLimit.TEN,
				skip: 0,
				creatorId: userId,
			}
		})
	);

	promises.push(
		axios.get(`partner-assignments`, {
			params: {
				trainerId: userId,
			},
		})
	);

	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const workoutCats = values[0].data;
			const programCats = values[1].data;
			const trainerWorkouts = values[2].data;
			const partnerAssignmentData = values[3].data;
			dispatch({
				type: FETCH_WORKOUT_CATS,
				payload: workoutCats,
			});
			dispatch({
				type: FETCH_PROGRAM_CATS,
				payload: programCats,
			});
			dispatch({
				type: FETCH_WORKOUTS,
				payload: trainerWorkouts,
			});
			dispatch({
				type: FETCH_PARTNER_ASSIGNMENTS,
				payload: partnerAssignmentData,
			});
			dispatch(hideLoader());
			respond('got the goods');
		});
	});
};



export const fetchClients = (query) => dispatch => {
	const promises = [];
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(
		axios.get('clients', {
			params: {
				...query,
			},
		})
	);
	if (query.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const data = values[0].data;
			dispatch(hideLoader());
			dispatch({
				type: FETCH_CLIENTS,
				payload: data,
			});
			respond(data);
		});
	});
};

export const fetchGroups = (query) => dispatch => {
	const promises = [];
	axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
	promises.push(
		axios.get('groups', {
			params: {
				...query,
			},
		})
	);
	if (query.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((respond, rej) => {
		Promise.all(promises).then(values => {
			const data = values[0].data;
			dispatch(hideLoader());
			dispatch({
				type: FETCH_GROUPS,
				payload: data,
			});
		});
	});
};

export const resetClients = () => dispatch => {
	dispatch({
		type: RESET_CLIENTS,
	});
};

export const resetGroups = () => dispatch => {
	dispatch({
		type: RESET_GROUPS,
	});
};


export const downloadPartners = (isReferUser) => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		let url = `/partners/downloadList`;
		if (isReferUser) {
			url = `${url}?isReferUser=${isReferUser}`;
		}
		axios
			.get(url, {})
			.then(res => {
				dispatch(hideLoader());
				if (Object.values(res.data).length === 0) {
					dispatch(showAlert('No memeber list found', true));
					reject();
				} else {
					response(res.data);
				}
			})
			.catch(function (error) {
				dispatch(hideLoader());
				reject();
			});
	});
};


export const fetchRegisterClientIds = () => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`/clients/registeredClientIds`, {})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				dispatch(hideLoader());
				reject();
			});
	});
};

export const fetchFBTokens = () => dispatch => {
	dispatch(showLoader());
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.post(`/users/getFBToken`, {})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				dispatch(hideLoader());
				reject();
			});
	});
};


export const fetchDownloads = (userId, param) => dispatch => {
	if (param.params.skip === 0) {
		dispatch(showLoader());
	}
	return new Promise((response, reject) => {
		axios.defaults.baseURL = process.env.REACT_APP_API_ROOT_REAL;
		axios
			.get(`${SERVICE}/downloadList`, {
				params: {
					type: param && param.params && param.params.type,
					startDate: param && param.params && param.params.startDate,
					skip: param && param.params && param.params.skip,
					limit: param && param.params && param.params.limit,
					search:
						param &&
						param.params &&
						param.params.search &&
						param.params.search.length &&
						param.params.search,
				},
			})
			.then(res => {
				dispatch(hideLoader());
				response(res.data);
			})
			.catch(function (error) {
				console.warn(error);
				dispatch(hideLoader());
				reject();
			});
	});
};



// WEBPACK FOOTER //
// ./src/store/actions/assignments.js